import { render, staticRenderFns } from "./ToolOptionsButton.vue?vue&type=template&id=6e2c03c0"
import script from "./ToolOptionsButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolOptionsButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports